import { Component, HostListener, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChildrenOutletContexts, NavigationEnd, Router, RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import defaultLanguage from "./../assets/i18n/pt.json";
import { LocalStorageService } from 'ngx-webstorage';
import { ScrollService } from './shared/services/scroll.service';
import { CookieService } from 'ngx-cookie-service';
import { DataLayerService } from './shared/services/data-layer.service';
import { FooterMenuComponent } from './site/footer-menu/footer-menu.component';
import { NavBarHomeComponent } from './site/nav-bar-home/nav-bar-home.component';

import { TopnavComponent } from './layout/components/topnav/topnav.component';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [TopnavComponent, NavBarHomeComponent, RouterOutlet, RouterLink, FooterMenuComponent]
})
export class AppComponent implements OnInit {
    divperguntasfrequentes = document.getElementById("divperguntasfrequentes");
    cookieConsent = false;
    normalNav: boolean = false;
    type: string;
    showNav: boolean = true;
    containsFooter: boolean;
    routesWithoutNavHome = ['dashboard', 'calc-menu', 'uploadCar', 'meus-dados', 'trocarsenha', 'parana-faz-ciencia'];
    typesWhite = ['sobre', 'solucoes', 'projetos', 'calculadora-menu', 'landpage'];
    routesWithFooter = ['/site', 'sobre', 'solucoes', 'projetos', 'faleconosco', 'transparencia', 'termos', 'politica'];
    routesWithoutFooter = ['login', 'calculadora-menu', 'criarconta', 'trocarsenha', 'landpage', 'parana-faz-ciencia'];
    constructor(
        public cookieService: CookieService,
        public translate: TranslateService,
        public scrollService: ScrollService,
        private contexts: ChildrenOutletContexts,
        private router: Router,
        private $localStorage: LocalStorageService,
        private _dataLayerService: DataLayerService) {
        translate.addLangs(['en', 'pt']);
        translate.setTranslation('pt', defaultLanguage);
        translate.setDefaultLang('pt');
        const browserLang = translate.getBrowserLang();
        translate.use(browserLang.match(/en|pt/) ? browserLang : 'pt');
        router.events.subscribe((event) => (event instanceof NavigationEnd) && this.handleRouteChangeNavMenu());
        router.events.subscribe((event) => (event instanceof NavigationEnd) && this.handleRouteChangeFooter());
        router.events.subscribe((event) => (event instanceof NavigationEnd) && this.handleNavMenu());
        this.cookieService.set('cookieConsent', 'false');
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
            this._dataLayerService.logPageView(event.url);
            }
            });
    }

    ngOnInit() {
        this.cookieConsent = this.$localStorage.retrieve("cookieConsent");
    }

    onCookieConsent() {
        this.cookieConsent = true;
        this.cookieService.set('cookieConsent', 'true');
        this.$localStorage.store("cookieConsent", this.cookieConsent);
    }

    handleNavMenu() {
        if (this.routesWithoutNavHome.some(el => this.router.url.includes(el))) {
            this.showNav = false;
            return;
        }
        this.showNav = true;
    }

    @HostListener('window:popstate', ['$event'])
    onPopState(event) {
        if (event.target.window.location.pathname.includes('dashboard') || event.target.location.pathname.includes('calc-menu')) {
            this.showNav = false;
            // localStorage.removeItem('isLoggedin');
            // this.loginService.logout();
        }
        if (event.target.window.location.pathname.includes('site')) {
            this.showNav = true;
        }
    }

    routeNone() {
        if (this.router.url === '/') {
            return false;
        }
        return true;
    }

    handleRouteChangeNavMenu = () => {
        if (this.typesWhite.some(el => this.router.url.includes(el))) {
            this.type = 'white';
            return;
        }
        this.type = '';
    };

    handleRouteChangeFooter = () => {
       
        if (this.routesWithFooter.some(el => this.router.url.includes(el)) && !this.routesWithoutFooter.some(el => this.router.url.includes(el))) {
            this.containsFooter = true;
            return;
        }
        this.containsFooter = false;
    };

    getRouteAnimationData() {
        return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
    }
}
